<script>
const ICON_MARKER_SIZE = Object.freeze({
  SMALL: "small",
  MEDIUM: "medium",
  BIG: "big",
});
</script>

<script setup>
defineProps({
  size: {
    type: String,
    validator: (prop) => Object.values(ICON_MARKER_SIZE).includes(prop),
    default: ICON_MARKER_SIZE.SMALL,
  },
});
</script>

<template>
  <div class="icon-marker" :class="{ [size]: true }">
    <span
      class="w-100 h-100 icon-marker-icon d-flex justify-content-center align-items-center"
    >
      <slot />
    </span>
  </div>
</template>

<style scoped lang="scss">
.icon-marker {
  border-radius: 8px;
  background: $neutral-0;
  border: 1px solid $neutral-200;
  display: flex;
  justify-content: center;
  align-items: center;

  &.small {
    width: 1.25rem;
    height: 1.25rem;
  }

  &.medium {
    width: 2rem;
    height: 2rem;
  }

  &.big {
    width: 2.75rem;
    height: 2.75rem;
  }

  &-icon {
    color: $bluish-gray-800;
  }
}
</style>
